export default __webpack_public_path__ + "static/media/SeptDom2024.5fa9e1d0.png";